// extracted by mini-css-extract-plugin
export default {"select":"styles_select__YZZK+","input":"styles_input__QhG-R"};